module.exports = __webpack_public_path__ + "img/silent.cc01a741.png";